<template>
  <EditarBase
    nomePlural="FuncionarioAfastamentoTipos"
    nomeSingular="FuncionarioAfastamentoTipo"
    :camposObrigatorios="camposObrigatoriosLimites"
    @recurso="setRecurso"
    @submitSuccess="emitSubmitSuccess"
    @submitError="emitSubmitError"
    @closeModalEdit="closeModalEdit"
  >
    <v-col cols="12">
      <v-row>
        <v-col cols="12" md="6">
          <span class="opacity-5 text-dark">
            {{ $t("Descricao") }}
          </span>
          <v-text-field
            v-model="recurso.descricao"
            :label="$t('Descricao')"
            name="descricao"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-col cols="12" md="6">
          <span class="opacity-5 text-dark">
            {{ $t("codigoExterno") }}
          </span>
          <v-text-field
            v-model="recurso.codigoExterno"
            :label="$t('codigoExterno')"
            name="codigoExterno"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
            clearable
          />
        </v-col>

        <v-col cols="12" md="6">
          <span class="opacity-5 text-dark">
            {{ $t("Tipo") }}
          </span>
          <v-select
            v-model="recurso.tipo"
            :items="tiposFuncionarioAfastamentos"
            item-text="text"
            item-value="value"
            :label="$t('Tipo')"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-col cols="12" md="6">
          <span class="opacity-5 text-dark">
            {{ $t("codMotAfast") }}
          </span>
          <v-select
            v-model="recurso.codMotAfast"
            :items="motivosAfastamentoESocial"
            item-text="text"
            item-value="value"
            :label="$t('codMotAfast')"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
            clearable
          />
        </v-col>

        <v-col cols="12" md="4">
          <span class="opacity-5 text-dark">
            {{ $t("Status") }}
          </span>
          <v-select
            v-model="recurso.statusComum"
            :items="itensStatusComum"
            item-text="text"
            item-value="value"
            :label="$t('Status')"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.disponivelApp">
            <template v-slot:label>
              {{ $t("disponivelApp") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.opcaoSupervisor">
            <template v-slot:label>
              {{ $t("opcaoSupervisor") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12">
          <div class="campo-config-title">{{ $t("limitesAfastamento") }}</div>
          <p class="text-caption mb-2">{{ $t("limitesAfastamentoAjuda") }}</p>
          <v-row
            v-for="limite in limitesRegistro"
            :key="limite.ativo"
            align="center"
          >
            <v-col cols="12" md="4">
              <v-checkbox
                v-model="recurso[limite.ativo]"
                :label="$t(limite.ativo)"
                hide-details
                @change="alterarLimite(limite)"
              />
            </v-col>
            <v-col v-if="recurso[limite.ativo]" cols="12" md="4">
              <v-text-field
                v-model.number="recurso[limite.quantidade]"
                :label="$t(limite.quantidade)"
                :name="limite.quantidade"
                :rules="[validarQuantidadeLimite]"
                type="number"
                min="1"
                step="1"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12">
          <div class="campo-config-title">{{ $t("Campos") }}</div>
          <v-simple-table dense class="campo-config-table">
            <thead>
              <tr>
                <th>{{ $t("Campo") }}</th>
                <th class="text-center">{{ $t("Visivel") }}</th>
                <th class="text-center">{{ $t("Obrigatorio") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in campoConfiguracaoItems" :key="item.campo">
                <td>{{ $t(item.label) }}</td>
                <td class="text-center">
                  <v-checkbox
                    v-model="recurso[item.visivel]"
                    dense
                    hide-details
                    class="ma-0 pa-0 justify-center"
                  />
                </td>
                <td class="text-center">
                  <v-checkbox
                    v-model="recurso[item.obrigatorio]"
                    dense
                    hide-details
                    class="ma-0 pa-0 justify-center"
                  />
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-col>
  </EditarBase>
</template>

<script>
import EditarBase from "@/components/base/Crud/EditarBase";
import listas from "@/mixins/listas";
import DataService from "@/services/pessoal/FuncionarioAfastamentoTipoDataService";

const MOTIVOS_AFASTAMENTO_ESOCIAL = [
  "ACIDENTE_DOENCA_TRABALHO",
  "ACIDENTE_DOENCA_NAO_RELACIONADA_TRABALHO",
  "AFASTAMENTO_SERVIDOR_SEM_REMUNERACAO",
  "APOSENTADORIA_INVALIDEZ",
  "ACOMPANHAMENTO_FAMILIAR_ENFERMO",
  "AFASTAMENTO_SERVIDOR_COM_REMUNERACAO",
  "CARCERE",
  "CARGO_ELETIVO_CELETISTA",
  "CARGO_ELETIVO_SERVIDOR_PUBLICO",
  "FERIAS_RECESSO",
  "LICENCA_REMUNERADA",
  "LICENCA_MATERNIDADE",
  "LICENCA_MATERNIDADE_PRORROGACAO_60_DIAS",
  "LICENCA_MATERNIDADE_ABORTO_NAO_CRIMINOSO",
  "LICENCA_MATERNIDADE_ADOCAO_GUARDA",
  "LICENCA_NAO_REMUNERADA",
  "MANDATO_ELEITORAL",
  "MANDATO_SINDICAL",
  "MULHER_VITIMA_VIOLENCIA",
  "QUALIFICACAO_ART_476_A_CLT",
  "SERVICO_MILITAR",
  "SERVIDOR_PUBLICO_DISPONIBILIDADE",
  "INATIVIDADE_TRABALHADOR_AVULSO",
  "LICENCA_MATERNIDADE_ANTECIPACAO_PRORROGACAO_ATESTADO",
  "AFASTAMENTO_MANDATO_ELETIVO_CARGO_COMISSAO",
  "IMPEDIMENTO_ESCALA_TRABALHO_AVULSO",
  "SUSPENSAO_PAGAMENTO_NAO_RECADASTRAMENTO",
  "EXERCICIO_OUTRO_ORGAO_CEDIDO",
  "QUALIFICACAO_ART_15_LEI_14457",
  "QUALIFICACAO_ART_17_LEI_14457",
];

function getMotivosAfastamentoESocial(vm) {
  return MOTIVOS_AFASTAMENTO_ESOCIAL.map((value) => ({
    text: vm.$t(value),
    value,
  }));
}

export default {
  name: "EditarFuncionarioAfastamentoTipo",
  components: { EditarBase },
  mixins: [listas],
  props: {
    itemAtual: Object,
  },
  data() {
    return {
      DataService,
      motivosAfastamentoESocial: getMotivosAfastamentoESocial(this),
      campoConfiguracaoItems: this.getCampoConfiguracaoItems(),
      limitesRegistro: [
        {
          ativo: "limitarRegistrosSemana",
          quantidade: "quantidadeLimiteRegistrosSemana",
        },
        {
          ativo: "limitarRegistrosMes",
          quantidade: "quantidadeLimiteRegistrosMes",
        },
        {
          ativo: "limitarRegistrosPeriodo",
          quantidade: "quantidadeLimiteRegistrosPeriodo",
        },
        {
          ativo: "limitarRegistrosSemestre",
          quantidade: "quantidadeLimiteRegistrosSemestre",
        },
        {
          ativo: "limitarRegistrosAno",
          quantidade: "quantidadeLimiteRegistrosAno",
        },
      ],
      recurso: {
        id: null,
        descricao: "",
        codigoExterno: "",
        tipo: "",
        codMotAfast: null,
        disponivelApp: false,
        opcaoSupervisor: false,
        limitarRegistrosPeriodo: false,
        quantidadeLimiteRegistrosPeriodo: null,
        limitarRegistrosMes: false,
        quantidadeLimiteRegistrosMes: null,
        limitarRegistrosSemana: false,
        quantidadeLimiteRegistrosSemana: null,
        limitarRegistrosSemestre: false,
        quantidadeLimiteRegistrosSemestre: null,
        limitarRegistrosAno: false,
        quantidadeLimiteRegistrosAno: null,
        statusComum: "ATIVO",
      },
      itensStatusComum: [
        { text: this.$t("Ativo"), value: "ATIVO" },
        { text: this.$t("Inativo"), value: "INATIVO" },
      ],
    };
  },
  computed: {
    camposObrigatoriosLimites() {
      return this.limitesRegistro
        .filter((limite) => this.recurso[limite.ativo])
        .map((limite) => ({
          campo: limite.quantidade,
          label: limite.quantidade,
        }));
    },
  },
  mounted() {
    if (this.itemAtual?.id) {
      this.setRecurso(this.itemAtual);
      return;
    }
    this.carregarRecurso();
  },
  watch: {
    itemAtual: {
      deep: true,
      handler(recurso) {
        if (!recurso?.id || recurso.id === this.recurso?.id) {
          return;
        }
        this.setRecurso(recurso);
        if (this.recurso.tipo && !this.possuiConfiguracaoCampos(this.recurso)) {
          this.aplicarPadraoCamposPorTipo(recurso.tipo);
        }
      },
    },
    "recurso.tipo"(tipo) {
      if (!this.possuiConfiguracaoCampos(this.recurso)) {
        this.aplicarPadraoCamposPorTipo(tipo);
      }
    },
  },
  methods: {
    alterarLimite(limite) {
      if (!this.recurso[limite.ativo]) {
        this.recurso[limite.quantidade] = null;
      }
    },
    validarQuantidadeLimite(valor) {
      return (
        (Number.isInteger(Number(valor)) && Number(valor) > 0) ||
        this.$t("limiteRegistrosInvalido")
      );
    },
    emitSubmitSuccess(recursoAtualizado = this.recurso) {
      this.$emit("submitSuccess", recursoAtualizado);
    },
    emitSubmitError() {
      this.$emit("submitError");
    },
    closeModalEdit() {
      this.$emit("closeModalEdit");
    },
    carregarRecurso() {
      const id = this.$route?.params?.id || this.recurso?.id;
      if (!id) return;
      DataService.find(id)
        .then((response) => {
          this.setRecurso(response.data);
        })
        .catch((error) => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          console.log(error);
        });
    },
    setRecurso(recurso) {
      const possuiConfiguracao = this.possuiConfiguracaoCampos(recurso);
      const normalizado = this.normalizarRecurso(recurso || {});
      this.recurso = normalizado;
      if (!possuiConfiguracao) {
        this.aplicarPadraoCamposPorTipo(this.recurso.tipo);
      }
    },
    normalizarRecurso(recurso) {
      const normalizado = {
        ...recurso,
        tipo: this.normalizarEnum(recurso.tipo),
        codMotAfast: this.normalizarEnum(recurso.codMotAfast) || null,
        statusComum: this.normalizarEnum(recurso.statusComum) || "ATIVO",
        disponivelApp: this.normalizarBoolean(recurso.disponivelApp, false),
        opcaoSupervisor: this.normalizarBoolean(recurso.opcaoSupervisor, false),
        limitarRegistrosPeriodo: this.normalizarBoolean(
          recurso.limitarRegistrosPeriodo,
          false
        ),
        quantidadeLimiteRegistrosPeriodo:
          recurso.quantidadeLimiteRegistrosPeriodo ?? null,
        limitarRegistrosMes: this.normalizarBoolean(
          recurso.limitarRegistrosMes,
          false
        ),
        quantidadeLimiteRegistrosMes:
          recurso.quantidadeLimiteRegistrosMes ?? null,
        limitarRegistrosSemana: this.normalizarBoolean(
          recurso.limitarRegistrosSemana,
          false
        ),
        quantidadeLimiteRegistrosSemana:
          recurso.quantidadeLimiteRegistrosSemana ?? null,
        limitarRegistrosSemestre: this.normalizarBoolean(
          recurso.limitarRegistrosSemestre,
          false
        ),
        quantidadeLimiteRegistrosSemestre:
          recurso.quantidadeLimiteRegistrosSemestre ?? null,
        limitarRegistrosAno: this.normalizarBoolean(
          recurso.limitarRegistrosAno,
          false
        ),
        quantidadeLimiteRegistrosAno:
          recurso.quantidadeLimiteRegistrosAno ?? null,
      };
      if (normalizado.profissionalResponsavelCodigoRegistroConselhoFiscalizadorVisivel == null) {
        normalizado.profissionalResponsavelCodigoRegistroConselhoFiscalizadorVisivel =
          normalizado.profissionalResponsavelVisivel;
      }
      this.campoConfiguracaoItems.forEach((item) => {
        normalizado[item.visivel] = this.normalizarBoolean(
          normalizado[item.visivel],
          false
        );
        normalizado[item.obrigatorio] = this.normalizarBoolean(
          normalizado[item.obrigatorio],
          false
        );
      });
      return normalizado;
    },
    normalizarEnum(value) {
      if (!value || typeof value !== "object") {
        return value || "";
      }
      return value.name || value.value || value.codigo || value.cod || "";
    },
    normalizarBoolean(value, defaultValue = false) {
      if (value === null || value === undefined) {
        return defaultValue;
      }
      if (typeof value === "boolean") {
        return value;
      }
      if (typeof value === "string") {
        return value.toLowerCase() === "true";
      }
      return !!value;
    },
    getCampoConfiguracaoItems() {
      const campos = [
        ["substituto", "Substituto"],
        ["inicio", "Inicio_do_periodo"],
        ["encerramento", "Final_do_periodo"],
        ["observacao", "Observacao"],
        ["horas", "QuantidadeHoras"],
        ["inicioHorario", "Horario_inicio"],
        ["encerramentoHorario", "Horario_encerramento"],
        ["cid", "CID"],
        ["profissionalResponsavel", "ProfissionalResponsavel"],
        [
          "profissionalResponsavelCodigoRegistroConselhoFiscalizador",
          "ProfissionalResponsavelCodigoRegistroConselhoFiscalizador",
        ],
        ["periodoAquisitivoInicio", "periodoAquisitivoInicio"],
        ["periodoAquisitivoFinal", "periodoAquisitivoFinal"],
        ["abonoFerias", "abonoFerias"],
        ["abonoFeriasDias", "abonoFeriasDias"],
        ["imagem", "Imagem"],
        ["imagemHomologacao", "ImagemHomologacao"],
      ];
      return campos.map(([campo, label]) => ({
        campo,
        label,
        visivel: `${campo}Visivel`,
        obrigatorio: `${campo}Obrigatorio`,
      }));
    },
    possuiConfiguracaoCampos(recurso) {
      return this.campoConfiguracaoItems.some(
        (item) =>
          recurso &&
          (Object.prototype.hasOwnProperty.call(recurso, item.visivel) ||
            Object.prototype.hasOwnProperty.call(recurso, item.obrigatorio))
      );
    },
    aplicarPadraoCamposPorTipo(tipo) {
      if (!tipo) return;
      const semEncerramento = [
        "HORASABONADAS",
        "HORASCOMPENSATORIAS",
        "ATESTADOCOMPARECIMENTO",
        "FOLGACOMPENSATORIA",
        "TRABALHOEXTERNO",
        "TROCAPLANTAO",
        "RESETCICLOESCALA",
        "FERIADOMANUAL",
        "DESCONSIDERARFERIADO",
        "ADVERTENCIA",
        "AJUSTESALDOBH",
        "REDUCAOPROJECAO",
      ].includes(tipo);
      const comHorario = [
        "HORASABONADAS",
        "HORASCOMPENSATORIAS",
        "ATESTADOCOMPARECIMENTO",
        "SOBREAVISO",
      ].includes(tipo);
      const comQuantidadeHoras = ["REDUCAOPROJECAO", "AJUSTESALDOBH"].includes(
        tipo
      );
      const comCid = [
        "ATESTADOMEDICO",
        "ATESTADOMEDICOATE30DIAS",
        "INSS",
      ].includes(tipo);
      const ferias = tipo === "FERIAS";
      const comImagemApp = [
        "ATESTADOMEDICO",
        "ATESTADOMEDICOATE30DIAS",
        "ATESTADOCOMPARECIMENTO",
        "TROCAPLANTAO",
        "GALA",
        "LICENCALUTO",
        "JUSTICAELEITORAL",
        "LICENCAMATERNIDADE",
        "LICENCAPATERNIDADE",
        "INSS",
      ].includes(tipo);
      const observacaoOpcional = [
        "ATESTADOMEDICO",
        "ATESTADOMEDICOATE30DIAS",
        "ATESTADOCOMPARECIMENTO",
        "GALA",
        "LICENCALUTO",
        "JUSTICAELEITORAL",
        "LICENCAMATERNIDADE",
        "LICENCAPATERNIDADE",
        "INSS",
      ].includes(tipo);

      Object.assign(this.recurso, {
        substitutoVisivel: ferias,
        substitutoObrigatorio: false,
        inicioVisivel: true,
        inicioObrigatorio: true,
        encerramentoVisivel: !semEncerramento,
        encerramentoObrigatorio: !semEncerramento,
        observacaoVisivel: true,
        observacaoObrigatorio: !observacaoOpcional,
        horasVisivel: comQuantidadeHoras,
        horasObrigatorio: false,
        inicioHorarioVisivel: comHorario,
        inicioHorarioObrigatorio: comHorario,
        encerramentoHorarioVisivel: comHorario,
        encerramentoHorarioObrigatorio: comHorario,
        cidVisivel: comCid,
        cidObrigatorio: false,
        profissionalResponsavelVisivel: comCid,
        profissionalResponsavelObrigatorio: false,
        profissionalResponsavelCodigoRegistroConselhoFiscalizadorVisivel: comCid,
        profissionalResponsavelCodigoRegistroConselhoFiscalizadorObrigatorio: false,
        periodoAquisitivoInicioVisivel: ferias,
        periodoAquisitivoInicioObrigatorio: false,
        periodoAquisitivoFinalVisivel: ferias,
        periodoAquisitivoFinalObrigatorio: false,
        abonoFeriasVisivel: ferias,
        abonoFeriasObrigatorio: false,
        abonoFeriasDiasVisivel: ferias,
        abonoFeriasDiasObrigatorio: ferias,
        imagemVisivel: comImagemApp,
        imagemObrigatorio: comImagemApp,
        imagemHomologacaoVisivel: false,
        imagemHomologacaoObrigatorio: false,
      });
    },
  },
};
</script>

<style scoped>
.campo-config-title {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 8px;
}

.campo-config-table {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 4px;
}
</style>
